import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=49b35101&scoped=true"
import script from "./HeadInfo.vue?vue&type=script&lang=js"
export * from "./HeadInfo.vue?vue&type=script&lang=js"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&id=49b35101&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b35101",
  null
  
)

export default component.exports